
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea23d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea23d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $cdb5fe76d37af5b2$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["5ZPII","index.c3f9d0d9.js","3UCjn","chart.es.b498c68e.js","lq1HK","chartjs-plugin-datalabels.es.4b5a0771.js"]'));


//# sourceMappingURL=index.runtime.1425e1ea.js.map
